import { ColorMode } from '@/theme';
import { create } from 'zustand';

type ThemeStore = {
  mode: ColorMode;
  setMode: (m: ColorMode) => void;
};

export const useTheme = create<ThemeStore>(set => ({
  mode: 'light',
  setMode: m => {
    set({
      mode: m,
    });
  },
}));
